export const environment = {
    api: 'https://i970615ju4.execute-api.eu-west-1.amazonaws.com', //! DEV
    websocket: 'wss://2cdggvt6kb.execute-api.eu-west-1.amazonaws.com/dev?access_token=',
    cognito: {
        userPoolId: 'eu-west-1_Ejg1JUJXd',
        userPoolClientId: '1lm87habnd28p225deetbddak1'
    }

    // api: 'https://89cdcoz1ic.execute-api.eu-west-1.amazonaws.com', //! TEST
    // websocket: 'wss://t3qpweeg40.execute-api.eu-west-1.amazonaws.com/test?access_token=',
    // cognito: {
    //     userPoolId: 'eu-west-1_Gr5jo1ZGJ',
    //     userPoolClientId: '1bm1epir80gah230r52gig56sm'
    // }
};
